import { createRouter, createWebHistory } from 'vue-router';
// import Home from '../views/Home.vue';

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    // {
    //   name: 'home',
    //   path: '/film-archive-1/',
    //   component: Home,
    // },
    // {
    //   name: 'show',
    //   path: '/film-archive-1/show',
    //   component: Home,
    // },
    // {
    //   name: 'person',
    //   path: '/film-archive-1/person',
    //   component: Home,
    // },
    // {
    //   name: 'company',
    //   path: '/film-archive-1/company',
    //   component: Home,
    // },
    // {
    //   path: '/*',
    //   redirect: '/',
    // },
  ],
});

export default router;
